module.exports = __webpack_public_path__ + "static/img/42.5312414.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/42.gif
// module id = O4ZD
// module chunks = 0